import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classes from 'classnames'

import { Column } from '../components/Grid'

import ErrorMessage from '../components/ErrorMessage'

const FormGroup = (props) => {
    const { name, label, error, description, isHorizontal, hasFeedback, children } = props

    const content = (
        <Fragment>
            { children }
            { error && <ErrorMessage error={ error } /> }
            { description && <span className="description">{ description }</span> }
        </Fragment>
    )

    return (
        <div
            className={ classes(
                'form-group',
                error ? 'has-error' : null,
                hasFeedback ? 'has-feedback' : null
            ) }
        >
            { label && (
                <label
                    className={ classes('control-label', isHorizontal ? 'col-sm-3' : null) }
                    htmlFor={ name }
                >
                    { label }
                </label>
            ) }
            {
                isHorizontal
                    ? <Column span={ 6 }>{ content }</Column>
                    : content
            }
        </div>
    )
}

FormGroup.propTypes = {
    name         : PropTypes.string,
    label        : PropTypes.string,
    error        : PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    description  : PropTypes.string,
    isHorizontal : PropTypes.bool,
    hasFeedback  : PropTypes.bool
}

FormGroup.defaultProps = {
    isHorizontal : false,
    hasFeedback  : false
}

export default FormGroup
